{
  "Accessibility Menu": "Menu dostępności",
  "Reset settings": "Reset ustawień",
  "Close": "Zamknij",
  "Content Adjustments": "Dostosowanie zawartości",
  "Adjust Font Size": "Dostosuj rozmiar czcionki",
  "Highlight Title": "Podświetl tytuły",
  "Highlight Links": "Podświetl linki",
  "Readable Font": "Czytelna czcionka",
  "Color Adjustments": "Dostosowanie kolorów",
  "Dark Contrast": "Ciemny kontrast",
  "Light Contrast": "Jasny kontrast",
  "High Contrast": "Wysoki kontrast",
  "High Saturation": "Wysoka saturacja",
  "Low Saturation": "Niska saturacja",
  "Monochrome": "Monochromatyczność",
  "Contrast": "Kontrast",
  "Invert Colors": "Odwróć kolory",
  "Tools": "Narzędzia",
  "Reading Guide": "Pomocnik czytania",
  "Stop Animations": "Wstrzymaj animacje",
  "Big Cursor": "Duży kursor",
  "Increase Font Size": "Zwiększ rozmiar czcionki",
  "Decrease Font Size": "Zmniejsz rozmiar czcionki",
  "Letter Spacing": "Odstępy między literami",
  "Line Height": "Wysokość wierszy",
  "Font Weight": "Pogrubiona czcionka",
  "Dyslexia Font": "Czcionka dla dyslektyków",
  "Language": "Język",
  "Open Accessibility Menu": "Otwórz menu dostępności",
  "Widget Settings": "Ustawienia widżetu",
  "Widget Position": "Położenie widżetu",
  "Top Left": "Górny lewy",
  "Top Center": "Górny środek",
  "Top Right": "Górny prawy",
  "Center Left": "Środek lewy",
  "Center Right": "Środek prawy",
  "Bottom Left": "Dolny lewy",
  "Bottom Center": "Dolny środek",
  "Bottom Right": "Dolny prawy",
  "Screen Reader": "Czytnik ekranu",
  "Voice Navigation": "Nawigacja głosowa",
  "Custom Color": "Kolor niestandardowy",
  "Change the site's colors": "Zmień kolory witryny",
  "Backgrounds": "Tła",
  "Headings": "Nagłówki",
  "Contents": "Treści",
  "Reset colors": "Zresetuj kolory",
  "Image Desaturation": "Desaturacja obrazu",
  "Search languages": "Wyszukaj języki",
  "No languages found": "Nie znaleziono języków",
  "Accessibility Profiles": "Profile dostępności",
  "Motor Impaired": "Ograniczona motoryka",
  "Big cursor, voice navigation, and no animations.": "Duży kursor, nawigacja głosowa i brak animacji.",
  "Blind": "Niewidomy",
  "Screen reader helpers with higher contrast.": "Pomoc czytnika ekranu z wyższym kontrastem.",
  "Color Blind": "Daltonizm",
  "High contrast palette with desaturated media.": "Paleta o wysokim kontraście z przygaszonymi mediami.",
  "Dyslexia": "Dysleksja",
  "Friendly font, extra spacing, stronger weight.": "Przyjazna czcionka, większe odstępy i mocniejsze pogrubienie.",
  "Low vision": "Słaby wzrok",
  "Dark contrast and 130% magnification.": "Ciemny kontrast i powiększenie 130%.",
  "Cognitive & Learning": "Poznawcze i nauka",
  "Highlights key sections and enables voice help.": "Podkreśla kluczowe sekcje i włącza pomoc głosową.",
  "Seizure & Epileptic": "Ataki i epilepsja",
  "Stops animations and desaturates imagery.": "Zatrzymuje animacje i zmniejsza nasycenie obrazów.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Przewodnik czytania, wyróżnione linki i spokojniejsza paleta.",
  "Widget Size": "Rozmiar widżetu",
  "Default": "Domyślny",
  "Medium": "Średni",
  "Small": "Mały",
  "Color Blindness": "Daltonizm",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsja",
  "Simulates and assists users with color vision deficiencies.": "Symuluje i wspomaga użytkowników z zaburzeniami widzenia barw."
}
